<ng-container *ngIf="!!params">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-md-3 col-xs-12 sp-5">
            <tt-file-uploader ttLabelView="none" [(ttFiles)]="filesToUpload" ttMultiple ttAllowEmails ttDropZone></tt-file-uploader>
            <tt-button [hidden]="filesToUpload.length === 0" ttText="upload_pictures" ttIcon="fas fa-arrow-alt-from-bottom" (ttClick)="uploadFiles()" [ttLoading]="uploading"></tt-button>
        </tt-card>
    </div>

    <tt-tabs [(ttSelectedId)]="selectedDocumentType" (ttSelectedIdChange)="read()">
        <tt-tab ttId="d" ttLabel="documents_documents" ttIcon="far fa-file"></tt-tab>
        <tt-tab ttId="p" ttLabel="documents_pictures" ttIcon="far fa-image"></tt-tab>
        <tt-tab ttId="v" ttLabel="documents_videos" ttIcon="far fa-video"></tt-tab>
    </tt-tabs>
    <tt-documents-grid
        *ngIf="!(['mobile', 'tablet'] | mediaQuery)"
        #documentsGrid
        rememberId="w_documents.documents_grid"
        [params]="{ argtype: this.params.argtype, argvalue: this.params.argvalue, doctype: this.selectedDocumentType, onlyFilenames: '0', searchtext: '' }"
    ></tt-documents-grid>

    <ng-container *ngIf="(['mobile', 'tablet'] | mediaQuery) && !!get">
        <tt-card>
            <tt-input ttLabel="documents_search" [(ttModel)]="searchtext" ttShowClearButton></tt-input>
        </tt-card>
        <tt-list class="flex-1" [ttData]="documents" [ttFilter]="searchtext" ttShowFileExtensionIcon></tt-list>
    </ng-container>

    <tt-card class="col-xs-12 sp-5">
        <tt-button-settings ttWebpageName="documents" (ttClick)="openSettings($event)"></tt-button-settings>
    </tt-card>
</ng-container>
